'use client';

import { useTranslation } from 'next-i18next';
import { Anchor } from '@components/common';
import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/solid';
import { OfferPageInfobox } from '@components/templates/employer/offer/OfferPageInfobox';
import { CompaniesSlider } from './CompaniesSlider';

export const OfferPageStandaloneSection = () => {
  const { t } = useTranslation('common');

  return (
    <div className="mb-10 rounded-lg bg-surface px-5 py-10 shadow-lg">
      {/* Infobox */}
      <OfferPageInfobox />

      {/* Companies Slider */}
      <CompaniesSlider />

      {/* Contact Section */}
      <div className="my-5 flex items-center justify-center gap-5">
        <Anchor
          rounding="full"
          styling="none"
          color="primary"
          href={`tel:${t('global.support.phoneNr')}`}
          className="mr-2 flex items-center justify-center gap-1 text-primary"
        >
          <PhoneIcon className="mr-2 w-4" />
          {t('global.support.phoneNr')}
        </Anchor>

        <Anchor
          rounding="full"
          styling="none"
          color="primary"
          href={`mailto:${t('global.support.email')}`}
          className="mr-2 flex items-center justify-center gap-1 text-primary"
        >
          <EnvelopeIcon className="mr-2 w-4" />
          {t('global.support.email')}
        </Anchor>
      </div>
    </div>
  );
};
